import { createComponent } from '@mtfe/sweet';
import style from './style.less';
import tpl from './dom.html';

/**
 * @param {Object} props 参数
 * @param {string} props.key DOM对应的惟一的key
 * @param {string} props.innerComponent 内部需要展示的组件
 * @returns
 */
const TabsPane = (props = {}) => {
    const { tabContainerID = '', innerComponent = '', defaultDisplay = false } = props;
    if (tabContainerID === '') {
        throw new Error('TabsPane: key must be a non-empty string');
    }
    if (typeof innerComponent !== 'string') {
        throw new Error('TabsPane: innerComponent must be a string');
    }
    const data = {
        ...props,
        isDisplay: defaultDisplay ? 'block' : 'none',
    };
    const events = {};
    const component = createComponent(tpl, { data, style }, events);
    return component;
};
export default TabsPane;
